import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPaymentLimits } from 'services/PaymentLimitsService'
import type { LimitsQueryParams } from 'types/paymentLimits'

export const useGetPaymentLimits = (params: LimitsQueryParams, isEnabled = true) => {
  return useQuery({
    queryKey: reactQueryKeys.paymentLimits(params),
    queryFn: () => getPaymentLimits(params),
    enabled: isEnabled && !!params.accountId,
  })
}
